import React, { useContext, createContext } from 'react';
import { noop } from 'lodash';

import {
  useGlobalSearchInternal,
  UseGlobalSearchReturnType,
} from 'hooks/useGlobalSearch/useGlobalSearchInternal';
import {
  SearchPageType,
  SearchPageCategory,
  SearchPageSortBy,
  SearchPageSortOrder,
} from 'lib/utils/global.search';
import { TOpportunity } from 'lib/models/opportunity';
import { TQueryParams } from 'utils/search';

const initialContext: UseGlobalSearchReturnType = {
  requestedPageType: SearchPageType.JOBS,
  originalType: SearchPageType.JOBS,
  type: SearchPageType.JOBS,
  category: SearchPageCategory.OPPORTUNITY,
  q: '',
  debouncedSearch: '',
  sortBy: SearchPageSortBy.MOST_RELEVANT,
  sortOrder: SearchPageSortOrder.DESC,
  isSearchModalOpen: false,
  partialFilter: {},
  currentFilters: [],
  isFiltersApplied: false,
  isPartialFiltersApplied: false,
  canShowOnboardingBanner: false,
  hasRequestedPageTypeChanged: false,
  initialQueryParamsReplaceLoading: false,
  searchLists: [],
  currentOpportunityPageSavedList: undefined,
  currentOpportunityPageQuery: null,
  showSavedListsModal: false,
  isListAdded: false,
  getFieldOptions: () => [],
  getFieldSubOptions: () => [],
  handleTypeChange: noop,
  handleSearchChange: noop,
  handleClearSearch: noop,
  handleFieldValueChange: noop,
  replaceQuery: noop,
  openSearchFilterModal: noop,
  closeSearchFilterModal: noop,
  onPartialChange: noop,
  onPartialUpdate: noop,
  onPartialFiltersUpdate: noop,
  onApplyPartialFilter: noop,
  onResetAppliedFilters: noop,
  onResetPartialFilters: noop,
  handleSortByChange: noop,
  closeOnboardingBanner: noop,
  fetchMoreCompanies: noop,
  setCompanySearchText: noop,
  handleSaveList: () => Promise.resolve(),
  handleDeleteList: () => Promise.resolve(),
  handleUpdateList: () => Promise.resolve(),
  openSavedListsModal: noop,
  closeSavedListsModal: noop,
  applySavedListQuery: noop,
  updateUserAction: noop,
  filterState: {},
  handleAddList: () => Promise.resolve(),
  setFilterState: noop,
};

const GlobalSearchContext =
  createContext<UseGlobalSearchReturnType>(initialContext);

export const useGlobalSearch = () => useContext(GlobalSearchContext);

export const GlobalSearchProvider: React.FC<{
  requestedPageType: SearchPageType | null;
  searchPageOpportunities?: Array<TOpportunity>;
  initialQueryParams: TQueryParams;
}> = ({ children, requestedPageType, initialQueryParams }) => {
  const value = useGlobalSearchInternal({
    requestedPageType,
    initialQueryParams,
  });

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
};
